<template>
  <div class="digital-article-weixin">
    <DigitalArticleView
      :width="isMobile ? '100%' : 600"
      :init-show="true"
      :init-show-prev-and-next="isFromContent"
      :init-show-close="false"
      :init-show-back="true"
      :init-article-text="articleText"
      @onBack="onBackArticleView"
      @onPrev="onPrevArticleView"
      @onNext="onNextArticleView"
      @onShare="onShare"
      ref="articleView"
    ></DigitalArticleView>
    <div class="digital-loading" v-if="dataLoading">
      <div class="text">{{ languageOption.loading }}</div>
    </div>
    <share-dialog v-if="!isMobile" ref="shareBookMsg" :qrObj="qrObj" :title="currentLang === 1 ? 'Share' : type === 'book' ? '分享电子书刊' : '分享数字报'"></share-dialog>
  </div>
</template>
<script>
import getBook from '@api/getBook'
import DigitalArticleView from '../components/digital/DigitalArticleView'
import ShareDilalog from '@/components/books/components/ShareDialog'
import { formatDigitalArticle } from '@/utils'
import wxSetting from '@components/common/wxSetting'
import subAccount from '@api/subAccount'
import ShareDialog from '@components/books/components/ShareDialog'
import statistics from '@components/books/statistics'
import chargeApi from '@api/chargeManager'
import moment from 'moment/moment'

export default {
  name: 'DigitalArticleMobile',
  mixins: [wxSetting, statistics],
  components: {
    ShareDialog,
    DigitalArticleView
  },
  data() {
    return {
      dataLoading: false,
      articles: [],
      epaperId: 0,
      pageIndex: 0,
      pageTotal: 0,
      articleIndex: 0,
      articleXiaoYangId: 0,
      articleTitle: '',
      articleText: '',
      readingLog: {},
      type: this.$route.query.type,
      isFromContent: this.$route.query.from == 'content',
      readModel: 0,
      qrObj: {
        value: '',
        iframeUrl: '',
        isShowPoster: 0
      },
      articleLayout: 0,
      articleHighlight: 0,
      daYangPic: '',
      coordinates: {},
      decryption_id: ''
    }
  },
  computed: {
    isMobile() {
      return this.$store.state.book.isMobile
    },
    userName() {
      return localStorage.getItem('username')
    },
    languageOption() {
      return this.$store.state.config.languageOptions[this.currentLang]
    },
    currentLang() {
      return this.$store.state.config.bookObj.language
    },
    isPaper() {
      return this.type.indexOf('paper') > -1
    }
  },
  mounted() {
    $('.common-header').hide()
    this.dataLoading = true
    this.getXiaoYangDetail(this.$route.query.id, async (data) => {
      this.epaperId = data.epaperId
      this.decryption_id = data.epaperId
      this.weixinShare(this.$route.query.id, data.title)
      // 从缓存中读取上一次的阅读的页数
      this.readingLog = JSON.parse(localStorage.getItem('readingLog')) || {}
      // 请求书刊详情
      if (data.module) {
        this.type = data.module.indexOf('epaper') > -1 ? 'paper' : 'book'
      }
      const params = {
        id: data.epaperId
      }
      this.issueDate = moment(data.publishDate).format('YYYY-MM-DD')
      this.baozhiId = data.baozhiId
      if (this.type === 'paper') {
        this.$store.commit('config/UPDATE_BOOK_ITEM', { name: 'issueDate', val: this.issueDate })
        await this.getBaozhiGoods()
      }
      this.getBookDetails(params, async (book) => {
        this.$store.commit('book/UPDATE_BOOK_DATA', book)
        let viewAble = await this.getViewAble(book)
        if (!viewAble) {
          return
        }
        //拿到报纸详情后，判断是否显示版面图以及高亮再 显示文章内容
        this.articleXiaoYangId = this.$route.query.id
        this.articleTitle = data.title
        this.articleLayout = book.articleLayout
        this.articleHighlight = book.articleHighlight
        if (this.articleLayout) {
          this.coordinates = JSON.parse(data.coordinates)
          //通过接口拿版面图
          this.findDaYangByXYId({ xiaoyangId: this.$route.query.id }, (daYang) => {
            this.daYangPic = daYang.picFile
            this.articleText = this.addPanelImage(data.content)
          })
        } else {
          this.articleText = data.content
        }
        this.$setDocumentTitle(data.title)
        this.$refs.articleView.articleId = this.articleXiaoYangId
        this.$refs.articleView.title = data.title
        this.$refs.articleView.creator = data.creator

        // 总页数
        this.pageTotal = book.pageNumber
        this.readModel = book.readModel
        this.$store.commit('config/UPDATE_LANGUAGE', book.language)
        // 导览文章列表
        if (book.catalog) {
          let catalog = JSON.parse(book.catalog)
          let articles = (catalog ? this.processCatalogList(catalog.catalogList, book.displayPageNo) : []) || []
          this.catalog = articles
          this.articles = this.getArticleIdsFromCatalog(articles)
          console.log(this.articles)
        } else {
          this.articles = []
        }
        if (this.type === 'book') {
          this.$store.commit('config/CHARGE', { type: 'bookObj', value: book.charge })
        }
        console.log('this.articles', this.articles)
        if (book.displayOrNot) {
          this.$store.commit('config/UPDATE_DISPLAY_OR_NOT', JSON.parse(book.displayOrNot))
        }
        this.getIpLocation()
        // 通过小样ID找到页面数和文章数
        for (let a in this.articles) {
          if (this.articles.hasOwnProperty(a)) {
            // 兼容pdf新增文章
            if (this.articles[a].xiaoYangId && this.articles[a].xiaoYangId == this.$route.query.id) {
              this.articleIndex = parseInt(a)
              break
            } /* else if (this.articles[a].children) {
              for (let b in this.articles[a].children) {
                if (this.articles[a].children.hasOwnProperty(b)) {
                  if (this.articles[a].children[b].xiaoYangId == this.$route.query.id) {
                    this.pageIndex = parseInt(a) + 1 //pdf新增文章版面与this.articles顺序不对应，需要改为this.articles实际索引
                    this.articleIndex = parseInt(b) + 1
                    console.log('this.pageIndex', this.pageIndex)
                    console.log('this.articleIndex', this.articleIndex)
                    break
                  }
                }
              }
            }*/
          }
        }
        this.$store.commit('common/UPDATE_GOODS_OBJ', { type: 'cover', value: book.path + '/1.jpg' })
        //
        setTimeout(() => {
          this.dataLoading = false
        }, 1000)
      })
      if (this.type === 'book') {
        this.getGoodsInfo()
      }
      this.$refs.articleView.edition = data.pageNo
    })
  },
  methods: {
    getArticleIdsFromCatalog(catalog) {
      let res = []
      catalog.forEach((item) => {
        if (item.xiaoYangId) {
          res.push(item)
        }
        if (item.children) {
          res = res.concat(this.getArticleIdsFromCatalog(item.children))
        }
      })
      return res
    },
    /* ---判断是否可查看--- */
    async getViewAble(data) {
      if (this.type === 'book') {
        return true
      }
      let viewAble = false
      //非发布状态，需要判断权限
      if (data.status !== 1) {
        if (this.$store.state.common.isLogin) {
          //登录用户，检查“查看权限”
          //查看权限。0-仅自己可见，1-所有团队账号可见，2-指定账号可见，默认0。值为2时，viewAccount值不为空"
          if (data.viewPrivilege === 0) {
            viewAble = data.creator === this.userName
          } else if (data.viewPrivilege === 1) {
            let res = await subAccount.getMainChildAccountList({
              userName: data.creator
            })
            if (res.data.data) {
              viewAble = res.data.data.includes(this.userName)
            }
          } else if (data.viewPrivilege === 2) {
            viewAble = data.viewAccount ? data.viewAccount.includes(this.userName) : false
          }
          // 审核者若未被设置可查看未发布作品权限，
          // 在提交审核前不显示作品，
          // 提交审核后显示作品，可进行查看、审核。
          if (!viewAble) {
            viewAble = data.status == 3 && data.auditAccount === this.userName
          }
        } else {
          // 未登录用户不可见
          this.$alert('请登录后查看', '提示', {
            confirmButtonText: '登录',
            showClose: false
          }).then(() => {
            window.location.href = window.PROJECT_CONFIG.BASE_URL + '/fxsso/login?service=' + window.encodeURIComponent(window.location.href)
          })
          return false
        }
      } else {
        viewAble = true
      }
      if (!viewAble) {
        this.$router.push('/none/401')
      }
      return viewAble
    },
    addPanelImage(content) {
      // 先找作者
      let contentMatched = content.match(/<div class="content_type content_type_0005".*?<\/div>/)
      //没有就找副题
      if (!contentMatched) {
        contentMatched = content.match(/<div class="content_type content_type_0003".*?<\/div>/)
      }
      //再没有找标题
      if (!contentMatched) {
        contentMatched = content.match(/<div class="content_type content_type_0002".*?<\/div>/)
      }
      if (contentMatched) {
        return content.replace(contentMatched[0], contentMatched[0] + this.createHtmlStr())
      } else {
        return this.createHtmlStr() + content
      }
    },
    createHtmlStr() {
      let str = `<div data-v-6f121812="" id="panelImgWrap" class="page-wrapper book-viewport"><img data-v-6f121812="" id="paperImg" src="${this.daYangPic}" alt="" class="page-img" onload="panelImgOnload()"></div>`
      window.panelImgOnload = () => {}
      if (this.articleHighlight) {
        let styleObj = {}
        window.panelImgOnload = () => {
          console.log(this.coordinates)
          console.log(paperImg.naturalWidth)
          console.log(paperImg.naturalHeight)
          if (this.coordinates.dingDianCount === 1) {
            styleObj.left = (this.coordinates.left / paperImg.naturalWidth) * 100 + '%'
            styleObj.right = ((paperImg.naturalWidth - this.coordinates.left - this.coordinates.width) / paperImg.naturalWidth) * 100 + '%'
            styleObj.top = (this.coordinates.top / paperImg.naturalHeight) * 100 + '%'
            styleObj.bottom = ((paperImg.naturalHeight - this.coordinates.top - this.coordinates.height) / paperImg.naturalHeight) * 100 + '%'
          } else {
            let left = 100,
              right = 0,
              top = 100,
              bottom = 0
            this.coordinates.dingDianList.forEach((element) => {
              let arr = element.split(',').map((item) => Number(item.replace('%', '')))
              if (arr[0] < left) {
                left = arr[0]
              }
              if (arr[0] > right) {
                right = arr[0]
              }
              if (arr[1] < top) {
                top = arr[1]
              }
              if (arr[1] > bottom) {
                bottom = arr[1]
              }
            })
            console.log({ left, right, top, bottom })
            styleObj.left = left + '%'
            styleObj.right = 100 - right + '%'
            styleObj.top = top + '%'
            styleObj.bottom = 100 - bottom + '%'
          }
          let str = `<div data-v-6f121812="" data-index="3" data-type="area" class="res-node area" style="top: ${styleObj.top}; left: ${styleObj.left}; right: ${styleObj.right}; bottom: ${styleObj.bottom}; z-index: 10;"><svg xmlns="http://www.w3.org/2000/svg" version="1.1" width="100%" height="100%">
						<defs>
							<linearGradient id="grad1" x1="0%" y1="0%" x2="100%" y2="100%">
								<stop offset="0%" stop-color="rgba(0,0,0,0.2)"></stop>
								<stop offset="100%" stop-color="rgba(255,255,255,0.5)"></stop>
								<stop offset="100%" stop-color="rgba(0,0,0,0.2)"></stop>
								<animate attributeName="x2" dur="1s" from="0%" to="100%" repeatCount="3"></animate>
								<animate attributeName="y2" dur="1s" from="0%" to="100%" repeatCount="3"></animate>
							</linearGradient>
						</defs>
						<rect fill="url(#grad1)" width="100%" height="100%"></rect>
					</svg></div>`
          console.log(styleObj)
          document.getElementById('panelImgWrap').insertAdjacentHTML('beforeend', str)
        }
      }
      return str
    },
    // 微信分享
    weixinShare(articleId, articleTitle) {
      let shareUrl = window.location.href
      let ua = window.navigator.userAgent.toLowerCase()
      if (ua.match(/MicroMessenger/i) == 'micromessenger') {
        const wxParams = {
          id: this.epaperId,
          currentUrl: shareUrl
        }
        this.getWXConfig(wxParams, this.type === 'book' ? getBook.getWXConfig : getBook.getPaperWXConfig, this.type !== 'book', articleTitle, shareUrl)
      } else {
        console.log('不是微信浏览器')
      }
    },
    // 书刊部分展示时，删除冗余页码目录
    processCatalogList(catalog, displayPageNo) {
      if (displayPageNo === 0 || !catalog) {
        return catalog
      }

      function deleteNode(arr) {
        let list = arr
        for (let i = 0; i < list.length; ) {
          if (list[i].page > displayPageNo) {
            list.splice(i, 1)
          } else if (list[i].children && list[i].children.length > 0) {
            deleteNode(list[i].children)
            i++
          } else {
            i++
          }
        }
      }

      deleteNode(catalog)
      return catalog
    },
    getBookDetails(params, callback) {
      let api = this.type === 'book' ? getBook.GetMobileBookDetails : getBook.GetPaperDetails
      api(params).then((res) => {
        if (res && res.data && res.status === 200) {
          callback(res.data.data)
        }
      })
    },
    getGoodsInfo() {
      //获取商品信息
      const param = {
        worksId: this.epaperId,
        worksType: 'cloud_read_ebook'
      }
      this.$store.commit('common/UPDATE_GOODS_OBJ', { type: 'worksId', value: this.epaperId })
      this.$store.commit('common/UPDATE_GOODS_OBJ', { type: 'worksType', value: 'cloud_read_ebook' })
      chargeApi.getGoodsInfo(param).then((res) => {
        let data = res.data.data
        if (data) {
          this.$store.commit('common/UPDATE_GOODS_OBJ', { type: 'period', value: data.period })
          this.$store.commit('common/UPDATE_GOODS_OBJ', { type: 'chargePage', value: data.trialOption === 1 ? this.totalPage : data.chargePage || 0 })
          this.$store.commit('common/UPDATE_GOODS_OBJ', { type: 'creator', value: data.creator })
          this.$store.commit('common/UPDATE_GOODS_OBJ', { type: 'price', value: data.price })
          this.$store.commit('common/UPDATE_GOODS_OBJ', { type: 'period', value: data.period })
          this.$store.commit('common/UPDATE_GOODS_OBJ', { type: 'worksName', value: data.worksName })
          this.$store.commit('common/UPDATE_GOODS_OBJ', { type: 'secret', value: data.secret })
          this.$store.commit('common/UPDATE_GOODS_OBJ', { type: 'articlePrice', value: data.articlePrice })
          this.$store.commit('common/UPDATE_GOODS_OBJ', { type: 'trialPercent', value: data.trialPercent })
          this.$store.commit('common/UPDATE_GOODS_OBJ', { type: 'trialOption', value: data.trialOption })
        }
      })
    },
    async getBaozhiGoods() {
      this.$store.commit('common/UPDATE_GOODS_OBJ', { type: 'worksId', value: this.baozhiId })
      this.$store.commit('common/UPDATE_GOODS_OBJ', { type: 'worksType', value: 'cloud_read_epaper' })
      await chargeApi.getGoodsInfo({ worksId: this.baozhiId, worksType: 'cloud_read_baozhi' }).then(async (res) => {
        let data = res.data.data
        if (data) {
          this.$store.commit('common/UPDATE_GOODS_OBJ', { type: 'secret', value: data.secret })
          this.$store.commit('common/UPDATE_GOODS_OBJ', { type: 'period', value: data.period })
          this.$store.commit('common/UPDATE_GOODS_OBJ', {
            type: 'chargePage',
            value: data.chargePage === -1 ? this.totalPage : data.chargePage || 0
          })
          this.$store.commit('common/UPDATE_GOODS_OBJ', { type: 'creator', value: data.creator })
          this.$store.commit('common/UPDATE_GOODS_OBJ', { type: 'price', value: data.price })
          this.$store.commit('common/UPDATE_GOODS_OBJ', { type: 'worksName', value: data.worksName })
          this.$store.commit('common/UPDATE_GOODS_OBJ', { type: 'secret', value: data.secret })
          this.$store.commit('common/UPDATE_GOODS_OBJ', { type: 'trialPercent', value: data.trialPercent })
          this.$store.commit('common/UPDATE_GOODS_OBJ', { type: 'trialOption', value: data.trialOption })
          if (data.issuePrice) {
            this.$store.commit('common/UPDATE_GOODS_OBJ', { type: 'issuePrice', value: JSON.parse(data.issuePrice) })
          }
          this.$store.commit('config/CHARGE', { type: 'bookObj', value: 1 })
          await chargeApi.queryEpaperReadable({ baoZhiId: this.baozhiId, issueDate: this.issueDate }).then((res) => {
            if (res.data.status === 0 && res.data.message.indexOf('可以阅读') > -1) {
              this.$store.commit('common/UPDATE_IS_ORDERED', true)
            } else {
              this.$store.commit('common/UPDATE_IS_ORDERED', false)
              if (res.data.status !== 0) {
                //数字报在允许试读期刊范围外的，不允许试读
                this.$store.commit('common/UPDATE_GOODS_OBJ', { type: 'chargePage', value: 0 })
              }
            }
            console.log('查询数字报是否可读', res.data)
          })
        } else {
          console.log('没有返回数据，默认不是商品，可以直接打开')
        }
      })
    },
    findDaYangByXYId(params, callback) {
      // let api = this.type === 'book' ? getBook.GetMobileBookDetails : getBook.findDaYangByXYId
      getBook.findDaYangByXYId(params).then((res) => {
        if (res && res.data && res.status === 200) {
          callback(res.data.data)
        }
      })
    },
    getXiaoYangDetailInfo(xiaoYangId) {
      if (xiaoYangId) {
        this.getXiaoYangDetail(xiaoYangId, (data) => {
          this.articleXiaoYangId = xiaoYangId
          this.articleTitle = data.title
          if (this.articleLayout) {
            this.coordinates = JSON.parse(data.coordinates)
            //通过接口拿版面图
            this.findDaYangByXYId({ xiaoyangId: xiaoYangId }, (daYang) => {
              this.daYangPic = daYang.picFile
              this.articleText = this.addPanelImage(data.content)
            })
          } else {
            this.articleText = data.content
          }
          this.$refs.articleView.articleId = this.articleXiaoYangId
          this.$refs.articleView.title = data.title
          this.$refs.articleView.creator = data.creator
          this.$refs.articleView.edition = data.pageNo
          document.title = data.title
          this.weixinShare(xiaoYangId, data.title)
        })
      }
    },
    getXiaoYangDetail(xiaoYangId, callback) {
      // 根据小样ID获取内容详情
      const params = {
        id: xiaoYangId,
        sentenceRead: 1 // 移动端要先获取小样详情再获取电子书详情，所以需要传sentenceRead=1
      }
      getBook.getXiaoYangDetail(params).then((res) => {
        if (res && res.data && res.status === 200 && res.data.status === 0) {
          callback && callback(formatDigitalArticle(res).data.data)
        } else {
          callback && callback({ title: '', content: '' })
        }
      })
    },
    repairAlert() {
      // 移动端时需要修复一下弹窗的层级问题
      if (this.isMobile) {
        setTimeout(() => {
          for (let a in document.body.children) {
            if (document.body.children.hasOwnProperty(a)) {
              let tabindex = parseInt(document.body.children[a].getAttribute('tabindex'))
              let className = document.body.children[a].className
              if (className.indexOf('el-message-box__wrapper') >= 0 && tabindex === -1) {
                document.body.children[a].style.zIndex = 10000
              } else if (className.indexOf('v-modal') >= 0 && tabindex === 0) {
                document.body.children[a].style.zIndex = 9999
              }
            }
          }
        }, 100)
      }
    },
    saveReadingLog(pageIndex) {
      // 保存当前阅读的页数
      this.readingLog[this.epaperId] = parseInt(pageIndex)
      localStorage.setItem('readingLog', JSON.stringify(this.readingLog))
    },
    onBackArticleView() {
      if (this.$route.query.from === 'content' && window.history.length > 2) {
        window.history.go(-1)
      } else {
        let path = this.type === 'book' ? '/content' : '/paperContent'
        this.$router.push({ path: path, query: { id: this.epaperId } })
      }
    },
    onPrevArticleView() {
      if (this.articleIndex === 0) {
        this.$alert('已经是第一篇文章', '提示', {
          confirmButtonText: '确定'
        })
        this.repairAlert()
        return
      }
      let articleIndex = this.articleIndex - 1
      let xiaoYangId = this.articles[articleIndex]?.xiaoYangId || 0
      if (xiaoYangId === 0) {
        return
      }
      this.articleIndex = articleIndex
      this.getXiaoYangDetailInfo(xiaoYangId)
    },
    onNextArticleView() {
      if (this.articleIndex >= this.articles.length - 1) {
        this.$alert('已经是最后一篇文章', '提示', {
          confirmButtonText: '确定'
        })
        if (this.$store.state.book.isListenAndRead) {
          this.$store.commit('book/UPDATE_IS_LISTEN_AND_READ', false)
        }
        this.repairAlert()
        return
      }
      let articleIndex = this.articleIndex + 1
      let xiaoYangId = this.articles[articleIndex].xiaoYangId || 0
      if (xiaoYangId === 0) {
        return
      }
      this.articleIndex = articleIndex
      this.getXiaoYangDetailInfo(xiaoYangId)
    },
    onShare() {
      this.shareBook(window.location.origin + '/elecPublish' + '/digitalArticle?id=' + this.articleXiaoYangId + '&voiceNumber=' + this.voiceNumber, '', '', this.articleTitle)
    },
    shareBook(link, poster, posterPic, title) {
      this.$refs.shareBookMsg.dialogVisible = true
      this.$store.commit('config/UPDATE_POSTERBG', posterPic)
      this.$store.commit('config/UPDATE_POSTER', poster)
      this.qrObj.value = link
      this.qrObj.iframeUrl = '<iframe src="' + this.qrObj.value + '" style="width:100%;height:99.5%"></iframe>'
      this.qrObj.isShowPoster = poster
      this.qrObj.title = title
    }
  },
  destroyed() {
    $('.common-header').show()
  }
}
</script>
<style lang="scss">
.digital-article-weixin {
  width: 100%;
  height: 100%;
  .digital-article-view {
    position: relative;
    margin: auto;
  }
  .page-wrapper {
    width: 50%;
    margin: 10px auto;
    position: relative;
    .page-img {
      width: 100%;
    }
    .area {
      position: absolute;
      svg {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        pointer-events: none;
        z-index: 2;
      }
    }
  }
}
</style>
